<template>
  <div class="sidebar">
    <el-menu
      class="sidebar-menu"
      background-color="transparent"
      text-color="#B3BAC5"
      active-text-color="#10A881"
      :default-active="activeMenu"
      unique-opened
      router
    >
      <el-menu-item index="/dashboard">
        <i class="menu-icon el-icon-s-grid"></i>
        <span slot="title">概况</span>
        <i class="el-icon-arrow-right menu-arrow"></i>
      </el-menu-item>
      
      <!-- 动态菜单 -->
      <template v-for="menu in userMenus">
        <!-- 有子菜单的情况 -->
        <el-submenu v-if="menu.children && menu.children.length" :index="menu.id.toString()" :key="menu.id" class="submenu-item">
          <template slot="title">
            <i class="menu-icon" :class="getMenuIcon(menu.name)"></i>
            <span>{{ menu.name.replace(/利息/g, '延期费用') }}</span>
            <i class="el-icon-arrow-right menu-arrow"></i>
          </template>
          <el-menu-item 
            v-for="child in menu.children" 
            :key="child.id" 
            :index="child.path" 
            class="submenu-child"
          >
            {{ child.name.replace(/利息/g, '延期费用') }}
          </el-menu-item>
        </el-submenu>
        
        <!-- 没有子菜单的情况 -->
        <el-menu-item v-else :index="menu.path" :key="menu.id">
          <i class="menu-icon" :class="getMenuIcon(menu.name)"></i>
          <span slot="title">{{ menu.name.replace(/利息/g, '延期费用') }}</span>
          <i class="el-icon-arrow-right menu-arrow"></i>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import { mapGetters } from 'vuex'

export default {
  name: 'Sidebar',
  data() {
    return {
      userMenus: []
    }
  },
  created() {
    this.getUserMenus()
  },
  computed: {
    ...mapGetters(['menuTreeFromPermissions']),
    
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // 如果当前路由设置了meta.activeMenu，则使用它
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    }
  },
  methods: {
    getUserMenus() {
      // 优先使用权限树构建菜单
      const menuTreeFromPermissions = this.menuTreeFromPermissions
      
      if (menuTreeFromPermissions && menuTreeFromPermissions.length > 0) {
this.userMenus = menuTreeFromPermissions
        return
      }
      
      // 后备：使用旧版menus
      const userInfo = getUserInfo()
if (userInfo && userInfo.menus && userInfo.menus.length > 0) {
// 构建菜单树
        this.userMenus = this.buildMenuTree(userInfo.menus)
} else {
        console.warn('未找到用户菜单数据')
        this.userMenus = []
      }
    },
    
    // 构建菜单树结构（用于旧版menus）
    buildMenuTree(menus) {
      const menuMap = new Map()
      const rootMenus = []
      
      // 首先创建所有菜单项的映射，并保证children为数组
      menus.forEach(menu => {
        menuMap.set(menu.id, {
          ...menu,
          children: []
        })
      })
      
      // 构建树结构
      menus.forEach(menu => {
        const menuItem = menuMap.get(menu.id)
        if (menu.parentId === 0) {
          // 根菜单
          rootMenus.push(menuItem)
        } else {
          // 子菜单
          const parentMenu = menuMap.get(menu.parentId)
          if (parentMenu) {
            parentMenu.children.push(menuItem)
          }
        }
      })
      
      return rootMenus
    },
    
    getMenuIcon(label) {
      // 根据菜单标签返回相应的图标
      const iconMap = {
        '基本信息': 'el-icon-document',
        '客户管理': 'el-icon-user',
        '合同管理': 'el-icon-tickets',
        '订单管理': 'el-icon-shopping-cart-full',
        '结算管理': 'el-icon-trophy',
        '资金管理': 'el-icon-money',
        '数据管理': 'el-icon-s-data'
      }
      
      return iconMap[label] || 'el-icon-s-operation'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.sidebar {
  flex: 1;
  overflow-y: auto;
  
  .sidebar-menu {
    height: 100%;
    border-right: none;
    
    ::v-deep .el-menu-item,
    ::v-deep .el-submenu__title {
      height: 52px;
      line-height: 52px;
      color: $sidebar-text;
      position: relative;
      transition: color 0.2s, background 0.2s;
      
      &:hover {
        background-color: rgba(16, 168, 129, 0.12) !important;
        color: $sidebar-text-active;
      }
    }
    
    ::v-deep .el-menu-item {
      display: flex;
      align-items: center;
      padding-left: 18px !important;
      
      .menu-icon {
        color: rgba(16, 168, 129, 0.75);
        margin-right: 10px;
        font-size: 18px;
        transition: color 0.2s;
      }
      
      .menu-arrow {
        position: absolute;
        right: 16px;
        color: rgba(255, 255, 255, 0.35);
        font-size: 12px;
      }
      
      &:hover .menu-icon {
        color: $brand-secondary;
      }

      &:hover .menu-arrow {
        color: rgba(255, 255, 255, 0.6);
      }
    }
    
    ::v-deep .el-submenu__title {
      display: flex;
      align-items: center;
      padding-left: 18px !important;
      
      .menu-icon {
        color: rgba(16, 168, 129, 0.75);
        margin-right: 10px;
        font-size: 18px;
      }
      
      .menu-arrow {
        position: absolute;
        right: 16px;
        color: rgba(255, 255, 255, 0.35);
        font-size: 12px;
      }
      
      &:hover .menu-icon,
      &:hover .menu-arrow {
        color: $brand-secondary;
      }
      
      i.el-submenu__icon-arrow {
        display: none;
      }
    }
    
    ::v-deep .el-menu--inline {
      background-color: rgba(0, 0, 0, 0.15) !important;
      
      .el-menu-item {
        height: 40px;
        line-height: 40px;
        padding-left: 46px !important;
        min-width: 180px;
        font-size: 13px;
        
        &:hover {
          background-color: rgba(16, 168, 129, 0.1) !important;
          color: $sidebar-text-active;
        }
      }
    }
    
    ::v-deep .el-menu-item.is-active {
      background: linear-gradient(90deg, rgba(16, 168, 129, 0.22) 0%, rgba(16, 168, 129, 0.04) 100%) !important;
      color: $sidebar-text-active;
      position: relative;
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 8px;
        bottom: 8px;
        width: 3px;
        border-radius: 0 2px 2px 0;
        background: linear-gradient(180deg, $brand-secondary, $brand-primary-light);
      }
      
      .menu-icon {
        color: $brand-secondary;
      }

      .menu-arrow {
        color: rgba(255, 255, 255, 0.7);
      }
    }
    
    ::v-deep .el-submenu.is-active {
      > .el-submenu__title {
        color: $sidebar-text-active;
        
        .menu-icon {
          color: $brand-secondary;
        }
      }
    }
  }
}
</style>
